<template>
  <div>
    <v-app>
      <v-container>
        <div class="text-xs-center mt-5">
          <div class="display-2">404</div>
          <div class="Headline">Not found this page</div>
        </div>
      </v-container>
    </v-app>
  </div>
</template>

<script>
export default {}
</script>

<style scoped></style>
